<template>
  <div class="modal-mask" v-if="show">
    <div id="statement-pop" class="statement-pop" style="height: auto;">
      <div class="closen" @click="closeStatement">+</div>
      <h2 class="title">严正声明</h2>
      <div class="content-wrapper">
        <p class="content">近日,我司部分加盟商私自转让加盟店的股权,以“加盟快乐番薯项目”的名义诈骗钱财,给我司声誉带来影响,对此我司严正声明如下：</p>
        <p class="content">一、部分加盟商以所谓的“加盟快乐番薯项目”进行诈骗的行为与我司无任何关系,我司不承担因此产生的任何法律责任。我司严厉谴责部分加盟商上述欺诈行为,敬请该等加盟商立即停止欺诈行为,消除影响。同时,因该等不法行为给我司造成的负面影响,我司将依法采取维权措施,依法追究相关人士的法律责任。</p>
        <p class="content">二、我司总部位于：<b>厦门市思明区海西金谷广场T1-23</b>拥有正规的加盟渠道,详情可访问我司唯一官网：<b>www.klfspp.com</b>及唯一官方热线：<b>400-6600-326</b>；其他以快乐番薯名义运营的网站均与我司无关。欢迎通过正规渠道加盟。同时提醒广大群众提高警惕,谨防上当受骗！</p>
        <div class="markt">
          <p style="margin-bottom: 2px;">厦门快乐番薯股份有限公司</p> <p>2021年6月4日</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
	export default {
    name: 'KlfsShengMing',
		data() {
			return {
        show: false
			}
		},
		created() {
      var now_timestamp = new Date().getTime();
      var old_timestamp = sessionStorage.getItem('modal_timestamp');
      if(old_timestamp) {
        old_timestamp = Number(old_timestamp);
        if(Number(now_timestamp-old_timestamp) / 1000 / 60 / 60 > 1) {
          this.show = true
        } else {
          this.show = false
        }
      } else {
        this.show = true
      }
		},
    mounted() {

    },

		methods: {
      closeStatement() {
        this.show = false
        var timestamp = new Date().getTime();
        sessionStorage.setItem('modal_timestamp', timestamp);
      }
		}
	}
</script>
<style scoped>
/*声明弹窗*/
.modal-mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  background: rgba(0,0,0,.7);
  z-index: 100000;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all .3s;
}
.modal-mask .statement-pop .content-wrapper .markt {
  text-align: right;
  padding-bottom: 20px;
}
.modal-mask .statement-pop {
  display: block;
  width: 600px;
  position: relative;
  background-color: #fff;
}
.modal-mask .statement-pop:before {
  content: "";
  display: block;
  width: 80px;
  height: 70px;
  border-radius: 60px 60px 0 0;
  background-image: url(../assets/shareImg.png);
  background-repeat: no-repeat;
  background-position: 50% 30%;
  background-size: 70%;
  background-color: #fff;
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
}
.modal-mask .statement-pop .closen {
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
  font-size: 30px;
  font-weight: 900;
  transform: rotate(45deg);
  color: #333;
  user-select: none;
}
.modal-mask .statement-pop .title {
  margin: 60px auto 0;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: #000;
}
.modal-mask .statement-pop .content-wrapper {
  margin-top: 20px;
  padding-left: 38px;
  padding-right: 38px;
  font-size: 14px;
  line-height: 20px;
  color: #333;
  max-height: 440px;
  overflow-y: auto;
}
.modal-mask .statement-pop .content-wrapper .content {
  text-indent: 26px;
  margin-bottom: 20px;
  line-height: 28px;
}
@media screen and (max-width:768px) {
  .modal-mask .statement-pop .content-wrapper {
    padding-left: 24px;
    padding-right: 24px;
    margin-top: 10px;
  }
  .modal-mask .statement-pop {
    width: 90%;
  }
  .modal-mask .statement-pop .title {
    margin-top: 50px;
  }
}
</style>